import { motion } from "framer-motion";
import { CONFIG, IMAGES } from "../../lib/config";

const acts = [
  { name: "NOKUJI", tag: "1er DJ set — Live", revealed: true, img: IMAGES.nokuji },
  { name: "DJ SURPRISE", tag: "Set non annoncé", revealed: false, img: IMAGES.redClub },
  { name: "B2B SECRET", tag: "Deux DJ, une scène", revealed: false, img: IMAGES.crowd },
  { name: "DANSE / PERFO", tag: "Performances live", revealed: false, img: IMAGES.nokuji },
  { name: "AKTRA CREW", tag: "Résidents", revealed: true, img: IMAGES.heroEclipse },
  { name: "GUEST", tag: "Invité·e mystère", revealed: false, img: IMAGES.redClub },
];

export default function Lineup() {
  return (
    <section
      id="lineup"
      data-testid="lineup-section"
      className="border-t border-white/10 bg-[#09090b] py-24 lg:py-40"
    >
      <div className="mx-auto max-w-[1600px] px-5 lg:px-10">
        <div className="mb-14 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
          <div>
            <p className="mb-4 font-mono-x text-xs uppercase tracking-[0.3em] text-[#FF0000]">
              [ Line-up ]
            </p>
            <h2 className="font-display text-5xl uppercase leading-[0.9] tracking-tight text-white lg:text-7xl">
              La<br />programmation
            </h2>
          </div>
          <p className="max-w-sm text-base leading-relaxed text-zinc-400">
            Nokuji en tête d’affiche, et beaucoup d’autres qu’on ne dévoile pas. Des DJ, de la
            danse, des invités. Le reste&nbsp;? Tu le découvriras sur place.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-px sm:grid-cols-2 lg:grid-cols-4">
          {acts.map((a, i) => (
            <motion.div
              key={a.name}
              data-testid={`lineup-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group relative aspect-[3/4] overflow-hidden bg-[#121214]"
            >
              <img
                src={a.img}
                alt={a.name}
                className={`absolute inset-0 h-full w-full object-cover transition-all duration-700 group-hover:scale-110 ${
                  a.revealed ? "opacity-45" : "opacity-20 blur-[3px] grayscale group-hover:blur-[1px]"
                }`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent" />
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <span className="font-mono-x text-[10px] uppercase tracking-[0.25em] text-[#FF0000]">
                  {a.tag}
                </span>
                <span className="mt-2 font-display text-2xl uppercase tracking-tight text-white lg:text-3xl">
                  {a.revealed ? a.name : "? ? ?"}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
